import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 80%;
  text-align: center;

  > span {
    font-size: 30px;
  }

  > div {
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.black7};
    max-width: 320px;
  }

  .ant-avatar-group {
    align-items: center;
  }
`;
